// @ts-nocheck
import { applyVueInReact } from 'vuereact-combined';

import RouterLink from '@/components/common/RouterLinkWrapper.vue';

const ReactRouterLink = applyVueInReact(RouterLink);

const RouterLinkComponent = ({ children, ...props }) => <ReactRouterLink {...props}>{children}</ReactRouterLink>;

export default RouterLinkComponent;
